import type { ClientKind } from '@/kinds/kind'
import { afterPatch, apply, defaults, displayName, initialStatus, validate } from './apply'
import { listSpec, listStatus, type ListSpec, type ListStatus } from './schema'
import { ListDetail, ListForm, ListRow } from './components'

export const listKind: ClientKind<ListSpec, ListStatus> = {
  name: 'List',
  version: 1,
  spec: listSpec,
  status: listStatus,
  defaults,
  validate,
  initialStatus,
  displayName,
  apply,
  afterPatch,
  actions: [
    'add_items',
    'tick',
    'untick',
    'edit_item',
    'remove_item',
    'move_item',
    'clear_ticked',
    'reset',
    'convert',
    'set_item_reminder',
  ],
  ListRow,
  Detail: ListDetail,
  Form: ListForm,
  workspaceScoped: true,
}

export * from './schema'
export type { ListResource } from './apply'
